import { getTimestampFromDate } from './dateUtil'
import ExcelJS from 'exceljs'

/**
 * CSVファイル名を返す関数
 * @param title CSVの種類
 * @returns CSVの種類CSV_タイムスタンプ
 */
export const getFileName = (title: string) => {
  return title + '_' + getTimestampFromDate(new Date(), 'YYYYMMDDhhmmss')
}

/**
 * CSV作成関数
 * @param header ヘッダー
 * @param res レスポンス {data: データ, filename: ファイル名}
 * @param fixName 拡張子「.csv」を付けるか(=true)
 */
export const createCSV = async <T>(header: any, data: T[], filename: string, fixName: boolean = true) => {
  const workbook = new ExcelJS.Workbook()
  if (workbook) {
    workbook.addWorksheet('sheet1')
    const worksheet = workbook.getWorksheet('sheet1')

    if (worksheet) {
      worksheet.columns = header
      worksheet.addRows(data)
      const uint8Array = await workbook.csv.writeBuffer() //csvの場合
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]) // BOMを埋め込む
      const blob = new Blob([bom, uint8Array], { type: 'application/octet-binary' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fixName ? getFileName(filename) + '.csv' : filename

      a.click()
      a.remove()
    }
  }
}
